export const SET_SELECTED_STATUS = 'selectedStatus';
export const SET_SEARCH_TEXT = 'searchText';
export const SET_EMPRESA = 'empresa';
export const SET_LOCAL_ENTREGA = 'localEntrega';
export const SET_CENTRO_CUSTO = 'centroCusto';
export const SET_PRODUTO = 'produto';
export const SET_PROJETO = 'projeto';
export const SET_RESPONSAVEL = 'responsavel';
export const SET_DATA_INICIAL = 'dataInicial';
export const SET_DATA_FINAL = 'dataFinal';
export const SET_DATA_FATURAMENTO_INICIAL = 'dataFaturamentoInicial';
export const SET_DATA_FATURAMENTO_FINAL = 'dataFaturamentoFinal';
export const SET_FILTER_BY_SAVING = 'filterBySaving';
export const SET_GRUPO = 'grupo';
export const SET_FORNECEDOR = 'fornecedor';
export const SET_FILTER = 'filter';
export const SET_LIST_OPTIONS = 'listOptions';
export const SET_CURRENT_SESSION_STATE = 'sessionState';
export const INIT_STATE = 'initState';
export const SET_PAGE = 'page';
export const SET_OFFSET = 'offset';
